import { SocietyAiAgentPageProvider } from '../pages/SocietyAiAgent/context/SocietyAiAgentPageContext';
import SocietyAiAgent from '../pages/SocietyAiAgent';

const SocietyAiAgentPageContainer = () => (
  <SocietyAiAgentPageProvider>
    <SocietyAiAgent />
  </SocietyAiAgentPageProvider>
);

export default SocietyAiAgentPageContainer;
